// web/src/api/filters/FiltersAPI.ts
import { AxiosInstance } from 'axios';

export default class FiltersAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async fetchCompanyList() {
    return this.client.get('/v2/global-filter/companies/');
  }

  async fetchCompanyEntityList(id: string | null) {
    if (id) {
      return this.client.get('/v2/global-filter/company-entities/');
    } else {
      return this.client.get('/v2/global-filter/company-entities/');
    }
  }

  async fetchSponsorList() {
    return this.client.get('/v2/global-filter/sponsors/');
  }

  async fetchInstrumentList() {
    return this.client.get('/v2/global-filter/instruments/');
  }

  async fetchCounterPartyList() {
    return this.client.get('/v2/global-filter/counter-parties/');
  }

  async fetchClassificationsList() {
    return this.client.get('/v2/global-filter/classifications/');
  }

  async fetchClusterList() {
    return this.client.get('/v2/global-filter/clusters/');
  }

  async fetchCurrencyList() {
    return this.client.get('/v2/global-filter/currencies/');
  }

  async fetchTrasnactionList() {
    return this.client.get('/v2/global-filter/transactions/');
  }
  async fetchAllTradesList() {
    return this.client.get(
      '/v2/global-filter/transactions/?reviewStatuses=1,2',
    );
  }

  async getHATrades() {
    return this.client.get(
      '/v2/global-filter/manage-hedge-accounting-transactions/',
    );
  }

  async fetchGvSponsorList() {
    return this.client.get('/v2/global-filter/gv-sponsors/');
  }

  async linkGvSponsorMapping(gvSponsorId: string, companyId: string) {
    return this.client.put(
      `/v2/global-filter/gv-sponsors/${gvSponsorId}/mapping/`,
      { company_id: companyId },
    );
  }

  async unlinkGvSponsorMapping(gvSponsorId: string) {
    return this.client.delete(
      `/v2/global-filter/gv-sponsors/${gvSponsorId}/mapping/`,
    );
  }
}
